var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input", {
        ref: "inputRef",
        attrs: {
          placeholder: "选择产品",
          disabled: _vm.disabled,
          readonly: "",
        },
        nativeOn: {
          click: function ($event) {
            return _vm.openSelectModal.apply(null, arguments)
          },
        },
        model: {
          value: _vm.pageData.materialName,
          callback: function ($$v) {
            _vm.$set(_vm.pageData, "materialName", $$v)
          },
          expression: "pageData.materialName",
        },
      }),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }